var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiasnessOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8361 10.5H9.10134C9.00432 10.5 8.95311 10.4406 8.93121 10.4051C8.90932 10.3697 8.87907 10.2973 8.92246 10.2105L10.2898 7.47579C10.3379 7.37959 10.4226 7.36523 10.4687 7.36523C10.5149 7.36523 10.5995 7.37959 10.6476 7.47579L12.015 10.2105C12.0584 10.2973 12.0281 10.3697 12.0062 10.4051C11.9843 10.4406 11.9331 10.5 11.8361 10.5Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4687 8.23606L9.5867 9.99999H11.3506L10.4687 8.23606ZM10.4687 6.86523C10.7172 6.86523 10.9658 6.99422 11.0948 7.25219L12.4621 9.98694C12.6949 10.4524 12.3564 11 11.8361 11H9.10129C8.58093 11 8.24248 10.4524 8.47519 9.98694L9.84257 7.25219C9.97156 6.99422 10.2201 6.86523 10.4687 6.86523Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5C18.8807 5 20 3.88071 20 2.5C20 1.11929 18.8807 0 17.5 0C16.1193 0 15 1.11929 15 2.5C15 3.88071 16.1193 5 17.5 5Z",
    fill: "#AECDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.5C18.6046 4.5 19.5 3.60457 19.5 2.5C19.5 1.39543 18.6046 0.5 17.5 0.5C16.3954 0.5 15.5 1.39543 15.5 2.5C15.5 3.60457 16.3954 4.5 17.5 4.5Z",
    stroke: "#AECDFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8C3.88071 8 5 6.88071 5 5.5C5 4.11929 3.88071 3 2.5 3C1.11929 3 0 4.11929 0 5.5C0 6.88071 1.11929 8 2.5 8Z",
    fill: "#AECDFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5C3.60457 7.5 4.5 6.60457 4.5 5.5C4.5 4.39543 3.60457 3.5 2.5 3.5C1.39543 3.5 0.5 4.39543 0.5 5.5C0.5 6.60457 1.39543 7.5 2.5 7.5Z",
    stroke: "#AECDFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18848 8.5L19.7515 4.75",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8361 10.5H9.10134C9.00432 10.5 8.95311 10.4406 8.93121 10.4051C8.90932 10.3697 8.87907 10.2973 8.92246 10.2105L10.2898 7.47579C10.3379 7.37959 10.4226 7.36523 10.4687 7.36523C10.5149 7.36523 10.5995 7.37959 10.6476 7.47579L12.015 10.2105C12.0584 10.2973 12.0281 10.3697 12.0062 10.4051C11.9843 10.4406 11.9331 10.5 11.8361 10.5Z",
    fill: "#272D55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4687 8.23606L9.5867 9.99999H11.3506L10.4687 8.23606ZM10.4687 6.86523C10.7172 6.86523 10.9658 6.99422 11.0948 7.25219L12.4621 9.98694C12.6949 10.4524 12.3564 11 11.8361 11H9.10129C8.58093 11 8.24248 10.4524 8.47519 9.98694L9.84257 7.25219C9.97156 6.99422 10.2201 6.86523 10.4687 6.86523Z",
    fill: "#272D55"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5C18.8807 5 20 3.88071 20 2.5C20 1.11929 18.8807 0 17.5 0C16.1193 0 15 1.11929 15 2.5C15 3.88071 16.1193 5 17.5 5Z",
    fill: "#AECDFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.5C18.6046 4.5 19.5 3.60457 19.5 2.5C19.5 1.39543 18.6046 0.5 17.5 0.5C16.3954 0.5 15.5 1.39543 15.5 2.5C15.5 3.60457 16.3954 4.5 17.5 4.5Z",
    stroke: "#AECDFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8C3.88071 8 5 6.88071 5 5.5C5 4.11929 3.88071 3 2.5 3C1.11929 3 0 4.11929 0 5.5C0 6.88071 1.11929 8 2.5 8Z",
    fill: "#AECDFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5C3.60457 7.5 4.5 6.60457 4.5 5.5C4.5 4.39543 3.60457 3.5 2.5 3.5C1.39543 3.5 0.5 4.39543 0.5 5.5C0.5 6.60457 1.39543 7.5 2.5 7.5Z",
    stroke: "#AECDFC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18848 8.5L19.7515 4.75",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiasnessOperationIcon);
export default __webpack_public_path__ + "static/media/BiasnessOperationIcon.c0ca66d0b825a9f8515d814d0922e9f5.svg";
export { ForwardRef as ReactComponent };